module.exports = __webpack_public_path__ + "static/media/vending_machine.47f4114e.webp";